<template>
  <v-app id="app">
    <div class="fade1"></div>
    <div class="fade2"></div>
    <v-card class="mx-auto overflow-hidden main-poll">
      <v-app-bar
        :color="darkMode ? 'primary darken-4' : 'primary'"
        v-if="!iframeMode"
        dark
        flat
        fix
        style="z-index: 2"
      >
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <v-app-bar-title>شیپ پُل</v-app-bar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="toggleDarkMode">
          <v-icon>
            {{ darkMode ? "mdi-weather-night" : "mdi-weather-sunny" }}
          </v-icon>
        </v-btn>
      </v-app-bar>
      <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
        right
        color="grey lighten-5"
        v-if="!iframeMode"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              سامانه سفارشی نظر سنجی</v-list-item-title
            >
            <v-list-item-subtitle> <a href="https://blog.shippoll.ir/">shippoll.ir</a>  </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list nav dense>
          <v-list-item-group v-model="group" color="deep-teal">
            <a href="https://blog.shippoll.ir/">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-title> بلاگ </v-list-item-title>
              </v-list-item>
            </a>
            <a href="https://blog.shippoll.ir/%d8%af%d8%b1%d8%a8%d8%a7%d8%b1%d9%87-%d9%85%d8%a7/">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-api</v-icon>
                </v-list-item-icon>
                <v-list-item-title> شیپ پول چیست؟</v-list-item-title>
              </v-list-item>
            </a>
            <a href="https://blog.shippoll.ir/%d9%88%db%8c%da%98%da%af%db%8c-%d9%87%d8%a7/">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-help</v-icon>
                </v-list-item-icon>
                <v-list-item-title> ویژگی های شیپ پول </v-list-item-title>
              </v-list-item>
            </a>
            <a href="https://blog.shippoll.ir/%d8%aa%d9%85%d8%a7%d8%b3-%d8%a8%d8%a7-%d9%85%d8%a7/">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-title> سفارش شیپ پول و تماس با ما</v-list-item-title>
              </v-list-item>
            </a>

          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <v-sheet>
        <v-main>
          <v-container id="container" :class="detectIframeClass()">
            <v-card
              outlined
              v-if="isFormMessage"
              :color="formMessageType"
              class="ma-1"
              dark
              style="z-index: 2"
            >
              <v-card-text class="text-center">
                <v-icon x-large>
                  {{
                    alertIcon.formMessageType
                      ? alertIcon.formMessageType
                      : "mdi-information"
                  }}
                </v-icon>
                <h2 style="margin: 2vh 0; line-height: 1.5">
                  {{ formMessage }}
                </h2>
              </v-card-text>
            </v-card>
            <div v-if="isForm && !isFormMessage">
              <template slot="progress">
                <v-progress-linear indeterminate></v-progress-linear>
              </template>
              <v-skeleton-loader
                v-if="submitLoading"
                type="card-heading,divider,list-item-three-line, divider, list-item-three-line, image, actions"
              ></v-skeleton-loader>
              <router-view v-show="submitLoading != true" />
            </div>
          </v-container>
          <p class="license">
            <a target="__blank" href="https://duvita.ir/">
              قدرت گرفته از دویتا
            </a>
          </p>
        </v-main>
      </v-sheet>
    </v-card>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    darkMode: false,
    drawer: false,
    group: null,
    iframeMode: false,
    alertIcon: {
      info: "mdi-information",
      warning: "mdi-alert",
      seccess: "mdi-check",
      error: "mdi-alert-octagram ",
      question: "mdi-progress-question ",
    },
  }),
  beforeCreate() {
    let url = window.location.search.slice(1).split("&", 1);
    this.$store.commit("updateUrl", url);
  },
  mounted() {
    this.detectIframe();
  },
  computed: {
    submitLoading: {
      get() {
        return this.$store.state.submitLoading;
      },
    },
    isForm: {
      get() {
        return this.$store.state.isForm;
      },
    },
    isFormMessage: {
      get() {
        return this.$store.state.isFormMessage;
      },
    },
    formMessage: {
      get() {
        return this.$store.state.formMessage;
      },
    },
    formMessageType: {
      get() {
        return this.$store.state.formMessageType;
      },
    },
  },
  methods: {
    detectIframe() {
      let isIframe = false;
      try {
        isIframe = window.self !== window.top;
      } catch (e) {
        isIframe = true;
      }
      // isIframe = true;
      this.iframeMode = isIframe;
    },
    detectIframeClass() {
      return {
        container: !this.iframeMode,
        "container-iframe": this.iframeMode,
      };
    },
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.darkMode = !this.darkMode;
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Vazir", sans-serif;
}
.container {
  max-width: 550px;
  padding: 8px;
  padding-top: 10vh !important;
}
.container-iframe {
  width: 100%;
  padding: 5px;
  padding-top: 10px !important;
}
.main-poll {
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.v-btn {
  letter-spacing: 0 !important;
  text-indent: 0.8em !important;
}

.license {
  text-align: center;
  opacity: 0.1;
  font-size:9px;
}
</style>
